import React from 'react';
import { FacebookIcon, InstagramIcon, WhatsAppIcon, YouTubeIcon, TelegramIcon, EmailIcon, PhoneIcon, LocationIcon, LinkedInIcon } from './IconComponents';
import Tooltip from './Tooltip';
import Link from './Link';

const Footer: React.FC = () => {
  return (
    <footer className="bg-slate-100 dark:bg-black text-slate-800 dark:text-white">
      <div className="container mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Column 1: About & Social */}
          <div>
            <img 
              loading="lazy" 
              src="https://res.cloudinary.com/dxohyfpnf/image/upload/h_72,c_scale,f_auto,q_auto/v1760489347/Black_w0ihji_ett9dp.webp" 
              alt="Global Fin X Logo" 
              width="94"
              height="36"
              className="h-9 w-auto mb-4 dark:hidden" 
              style={{ aspectRatio: '104 / 40' }}
            />
            <img 
              loading="lazy" 
              src="https://res.cloudinary.com/dxohyfpnf/image/upload/h_72,c_scale,f_auto,q_auto/v1760489348/White_bdvvxy_ovzvgt.webp" 
              alt="Global Fin X Logo" 
              width="94"
              height="36"
              className="h-9 w-auto mb-4 hidden dark:block" 
              style={{ aspectRatio: '104 / 40' }}
            />
            <p className="text-slate-600 dark:text-slate-400 text-sm mb-6">Your partner in achieving CMA US qualification and a successful career in finance.</p>
            <div className="flex flex-wrap gap-4">
              <Tooltip text="Follow on Facebook">
                <a href="https://www.facebook.com/GlobalFinX/" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="text-slate-500 dark:text-slate-400 hover:text-brand-accent dark:hover:text-brand-accent-dark transition-colors"><FacebookIcon className="w-6 h-6" /></a>
              </Tooltip>
              <Tooltip text="Follow on LinkedIn">
                <a href="https://www.linkedin.com/company/globalfinx" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" className="text-slate-500 dark:text-slate-400 hover:text-brand-accent dark:hover:text-brand-accent-dark transition-colors"><LinkedInIcon className="w-6 h-6" /></a>
              </Tooltip>
              <Tooltip text="Follow on Instagram">
                <a href="https://www.instagram.com/globalfinx/" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="text-slate-500 dark:text-slate-400 hover:text-brand-accent dark:hover:text-brand-accent-dark transition-colors"><InstagramIcon className="w-6 h-6" /></a>
              </Tooltip>
              <Tooltip text="Subscribe on YouTube">
                <a href="https://www.youtube.com/globalfinx" target="_blank" rel="noopener noreferrer" aria-label="YouTube" className="text-slate-500 dark:text-slate-400 hover:text-brand-accent dark:hover:text-brand-accent-dark transition-colors"><YouTubeIcon className="w-6 h-6" /></a>
              </Tooltip>
              <Tooltip text="Chat on WhatsApp">
                <a href="https://wa.me/918328080730" target="_blank" rel="noopener noreferrer" aria-label="WhatsApp" className="text-slate-500 dark:text-slate-400 hover:text-brand-accent dark:hover:text-brand-accent-dark transition-colors"><WhatsAppIcon className="w-6 h-6" /></a>
              </Tooltip>
               <Tooltip text="Join on Telegram">
                <a href="https://t.me/global_fin_x" target="_blank" rel="noopener noreferrer" aria-label="Telegram" className="text-slate-500 dark:text-slate-400 hover:text-brand-accent dark:hover:text-brand-accent-dark transition-colors"><TelegramIcon className="w-6 h-6" /></a>
              </Tooltip>
            </div>
          </div>
          
          {/* Column 2: CMA US Links */}
          <div>
            <h4 className="font-semibold mb-4 tracking-wide text-slate-900 dark:text-slate-100">CMA US</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to={{ page: 'cma-course-details' }} className="text-slate-600 dark:text-slate-400 hover:text-brand-accent dark:hover:text-brand-accent-dark cursor-pointer transition-colors">Course Details</Link></li>
              <li><Link to={{ page: 'cma-experience-requirement' }} className="text-slate-600 dark:text-slate-400 hover:text-brand-accent dark:hover:text-brand-accent-dark cursor-pointer transition-colors">Experience Requirement</Link></li>
              <li><Link to={{ page: 'cma-course-fee' }} className="text-slate-600 dark:text-slate-400 hover:text-brand-accent dark:hover:text-brand-accent-dark cursor-pointer transition-colors">Course Fee</Link></li>
            </ul>
          </div>

          {/* Column 3: Company Links */}
          <div>
            <h4 className="font-semibold mb-4 tracking-wide text-slate-900 dark:text-slate-100">Company</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to={{ page: 'about' }} className="text-slate-600 dark:text-slate-400 hover:text-brand-accent dark:hover:text-brand-accent-dark cursor-pointer transition-colors">About Us</Link></li>
              <li><Link to={{ page: 'contact' }} className="text-slate-600 dark:text-slate-400 hover:text-brand-accent dark:hover:text-brand-accent-dark cursor-pointer transition-colors">Contact Us</Link></li>
              <li><Link to={{ page: 'enroll-now' }} className="text-slate-600 dark:text-slate-400 hover:text-brand-accent dark:hover:text-brand-accent-dark cursor-pointer transition-colors">Enroll Now</Link></li>
              <li><Link to={{ page: 'terms-and-conditions' }} className="text-slate-600 dark:text-slate-400 hover:text-brand-accent dark:hover:text-brand-accent-dark cursor-pointer transition-colors">Terms & Conditions</Link></li>
              <li><Link to={{ page: 'privacy-policy' }} className="text-slate-600 dark:text-slate-400 hover:text-brand-accent dark:hover:text-brand-accent-dark cursor-pointer transition-colors">Privacy Policy</Link></li>
              <li><Link to={{ page: 'refund-policy' }} className="text-slate-600 dark:text-slate-400 hover:text-brand-accent dark:hover:text-brand-accent-dark cursor-pointer transition-colors">Refund Policy</Link></li>
            </ul>
          </div>
          
          {/* Column 4: Contact Info */}
          <div>
            <h4 className="font-semibold mb-4 tracking-wide text-slate-900 dark:text-slate-100">Contact Info</h4>
            <ul className="space-y-3 text-sm">
                <li className="flex items-start">
                    <LocationIcon className="w-5 h-5 mt-0.5 mr-3 flex-shrink-0 text-slate-600 dark:text-slate-400" />
                    <span className="text-slate-700 dark:text-slate-400">Hyderabad, Telangana, India</span>
                </li>
                 <li className="flex items-start">
                    <PhoneIcon className="w-5 h-5 mt-0.5 mr-3 flex-shrink-0 text-slate-600 dark:text-slate-400" />
                    <a href="tel:+918328080730" className="text-slate-700 dark:text-slate-400 hover:text-brand-accent dark:hover:text-brand-accent-dark cursor-pointer transition-colors">+91-8328080730</a>
                </li>
                 <li className="flex items-start">
                    <EmailIcon className="w-5 h-5 mt-0.5 mr-3 flex-shrink-0 text-slate-600 dark:text-slate-400" />
                    <a 
                      href="#" 
                      onClick={(e) => {
                          e.preventDefault();
                          window.location.href = "mailto:" + "info" + "@" + "globalfinx.in";
                      }}
                      className="text-slate-700 dark:text-slate-400 hover:text-brand-accent dark:hover:text-brand-accent-dark cursor-pointer transition-colors"
                    >
                      Email Us
                    </a>
                </li>
            </ul>
          </div>
        </div>
        <div className="mt-12 pt-8 border-t border-slate-200 dark:border-zinc-800 text-center text-sm text-slate-600 dark:text-slate-400">
          <p>&copy; {new Date().getFullYear()} Global Fin X. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;